module.exports = __webpack_public_path__ + "img/mobile-calendar-example.2581c10b.svg";